import { useEffect, useCallback } from 'react';
import {
    recevieUserReport,
    sendToKvReesultContainer,
} from '@/shared/ui/visang-viewer/kv-result-container';

export interface ReportEventListenerProps {
    subMitAnw: string;
    errata: number;
    hdwrtCn: string;
}

export const useReportEventListener = (result: ReportEventListenerProps | undefined) => {
    const notiFyTextbookHandprintingLoad = useCallback(
        (detail: any) => {
            const data = {
                article_id: detail?.article_id,
                sub_id: detail?.sub_id,
                resultDetailId: detail?.resultDetailId,
                hdwrtCn: result?.hdwrtCn,
            };
            sendToKvReesultContainer(data, 'notify-textbook-handprinting-load', detail.article_id);
        },
        [result]
    );

    const notiFyRecevieUserReport = useCallback(() => {
        if (result) {
            const data = {
                subMitAnw: result?.subMitAnw,
                errata: result?.errata,
            };
            recevieUserReport(data, 'receive-user-report');
        }
    }, [result]);

    const eventListener = useCallback(
        (e: any) => {
            const { type, detail: _detail } = e;
            let detail = null;
            try {
                detail = JSON.parse(_detail);
            } catch (e) {
                detail = _detail;
            }
            switch (type) {
                case 'textbook-handprinting-load':
                    notiFyTextbookHandprintingLoad(detail);
                    break;
                case 'loading-status':
                    setTimeout(() => notiFyRecevieUserReport(), 100);
                    break;
            }
        },
        [notiFyTextbookHandprintingLoad, notiFyRecevieUserReport]
    );

    useEffect(() => {
        window.addEventListener('custom-event', eventListener);
        return () => {
            window.removeEventListener('custom-event', eventListener);
        };
    }, [eventListener]);

    return { eventListener };
};
